var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goodsList"},[_c('hot-goods',{attrs:{"hotProducts":_vm.hotProducts}}),_c('all-goods',{attrs:{"allProducts":_vm.allProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }